/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Autofill_LabelInputs */

const en_login_autofill_label = /** @type {(inputs: Login_Autofill_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved passkey`)
};

const de_login_autofill_label = /** @type {(inputs: Login_Autofill_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeicherter Passkey`)
};

/**
* | output |
* | --- |
* | "Saved passkey" |
*
* @param {Login_Autofill_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_autofill_label = /** @type {((inputs?: Login_Autofill_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Autofill_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_autofill_label(inputs)
	return en_login_autofill_label(inputs)
});